import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { Drawer, Notification } from 'components/';
import { Query, QueryResult } from 'react-apollo';
import * as Queries from 'api/graphql/queries';
import * as Mutations from 'api/graphql/mutations';
import { getAllUrlAlias, OrderDirection } from '@api/graphql/types';
import { RowInfo, SortingRule } from 'react-table';
import Paths from '../paths';
import GraphQLClient from '@api/graphql/GraphQLClient';
import { ApolloQueryResult } from 'apollo-client';
import DeleteButton from '@components/DeleteButton';
import { Loading } from '@components/Loading';
import { DispatchProp } from 'react-redux';
import ReduxTable from '@components/ReduxTable';
import { OpenInNewCell } from '@components/Table/Cell';

const Columns = {
    Id: 'id',
    SourceUrl: 'source_url',
    TargetUrl: 'target_url',
    CreatedAt: 'created_at',
    UpdatedAt: 'updated_at',
};

export const UrlAliasListDefaultOptions = {
    sortBy: {
        field: Columns.Id,
        direction: OrderDirection.DESC,
    },
    count: 10,
    page: 0,
    filters: {
        'id': '',
        'source_url': '',
        'target_url': '',
        'created_at': '',
        'updated_at': '',
    },
};


const listName = 'urlAliasList';

type Props = DispatchProp & InjectedIntlProps & RouteComponentProps;

class UrlAliasList extends React.Component<Props> {
    private defaultSorted: SortingRule[] = [{id: 'id', desc: true}];
    private refetch: ((variables: any) => Promise<ApolloQueryResult<any>>) | undefined = undefined;

    private ActionCell = (row : any) => {
        return (
            <DeleteButton
                className="btn-xs"
                value={row.original.id}
                onClick={this.delete}
            />
        );
    }

    private OpenCell = OpenInNewCell((rowInfo: any) => {
        return `${Paths.urlAlias}/${rowInfo.original.id}`;
    });

    private tableColumns = [
        {Header: '', sortable: false, Cell: this.OpenCell, width: 30},
        this.getDefaultColumnByName(Columns.Id),
        this.getDefaultColumnByName(Columns.SourceUrl, {
            filterMethod: (filter: any, row: any) => row[Columns.SourceUrl].includes(filter.value),
        }),
        this.getDefaultColumnByName(Columns.TargetUrl, {
            filterMethod: (filter: any, row: any) => row[Columns.TargetUrl].includes(filter.value),
        }),
        this.getDefaultColumnByName(Columns.CreatedAt),
        this.getDefaultColumnByName(Columns.UpdatedAt),
        {Cell: this.ActionCell, filterable: false},
    ];

    private getDefaultColumnByName(name: string, options: any = {}) {
        return {
            Header: this.label(`${name}.title`),
            accessor: name,
            sortable: true,
            ...options,
        };
    }

    private delete = (id: string) => {
        GraphQLClient.mutate({
            mutation: Mutations.deleteUrlAlias, variables: { id },
        }).then(() => {
            if (this.refetch) {
                this.refetch(null);
            }
            return Notification.success(this.props.intl.formatMessage({id: 'notification.succeed'}));
        }).catch(() => {
            Notification.error(this.props.intl.formatMessage({id: 'notification.failed'}));
        });
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.urlAlias.${id}` });
    }

    private renderList(result: QueryResult<getAllUrlAlias>) {
        if (result.loading) return <Loading />;
        if (result.error) return `Error!: ${result.error}`;

        if (result.refetch) {
            this.refetch = result.refetch;
        }

        if (result.data && result.data.getAllUrlAlias) {
            return (
                <ReduxTable
                    columns={this.tableColumns}
                    listName={listName}
                    defaultOptions={UrlAliasListDefaultOptions}
                    data={result.data.getAllUrlAlias}
                    onClick={(rowInfo: RowInfo) => {
                        this.props.history.push(`${Paths.urlAlias}/${rowInfo.original.id}`);
                    }}
                    defaultSorted={this.defaultSorted}
                    defaultPageSize={10}
                />
            );
        }
        return null;
    }

    public render() {
        const addButton = <button className="btn btn-primary" onClick={(e: React.SyntheticEvent) => this.props.history.push(Paths.urlAliasCreate)}>Új átirányítás</button>;

        return (
            <Drawer headerButton={addButton}>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                <Query query={Queries.getAllUrlAlias}>
                                    {queryResult => this.renderList(queryResult)}
                                </Query>
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

export default compose(
    withRouter,
    injectIntl,
)(UrlAliasList);



// WEBPACK FOOTER //
// ./src/modules/UrlAlias/pages/UrlAliasList.tsx